<template>
    <pre ref="editorRef"></pre>
  </template>
  
  <script>
  import { ref, onBeforeUnmount, onMounted } from 'vue';
  
  export default {
    props: {
      document: {
        type: String,
        required: true,
        twoWay: true
      },
      commands: {
        type: Array,
        default: () => []
      }
    },
    setup(props, context) {
      const editorObj = ref(null);
      const editorRef = ref(null);
      
      onMounted(() => {
        ace.config.set('basePath', '/js/ace');
        editorObj.value = ace.edit(editorRef.value);
        editorObj.value.setValue(props.document);
        
        editorObj.value.on('change', () => {
          context.emit('update', editorObj.value.getValue());
        });
    
        props.commands.forEach(command => {
          editorObj.value.commands.addCommand(command);
        });

        editorObj.value.setTheme( 'ace/theme/custom' );
        editorObj.value.setShowPrintMargin(false);
        editorObj.value.setShowFoldWidgets(false);
        editorObj.value.setOption('fontSize', 14);
        editorObj.value.setAutoScrollEditorIntoView(true);
        editorObj.value.session.setMode('ace/mode/markdown');
        editorObj.value.session.setUseWrapMode(true);
        editorObj.value.renderer.setPadding(10);
        editorObj.value.renderer.setScrollMargin(10, 10);
      })
  
      onBeforeUnmount(() => {
        if (editorObj.value) {
          editorObj.value.off('change');
          editorObj.value.destroy();
        }
      });
  
      return {
        editorRef,
        editorObj
      };
    }
  }
  </script>